import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CustomerState } from './types'
import { CustomerService } from '../services/CustomerService'

const initialState: CustomerState = {
  // state
  isGetAllCustomerLoading: false,
  isExportCustomersLoading: false,
  isAddCustomerLoading: false,
  isGetCustomerNameLoading: false,
  isGetCustomerStatusLoading: false,
  isGetCustomerInfoLoading: false,
  isGetCustomerContactLoading: false,
  isGetCustomerNoteLoading: false,
  isGetCustomerTimestampLoading: false,
  isUpdateCustomerStatusLoading: false,
  isUpdateCustomerInfoLoading: false,
  isUpdateCustomerContactLoading: false,
  isUpdateCustomerNoteLoading: false,
  isGetAllTransactionByCustomerIdLoading: false,
  isGetCountTransactionByCustomerIdLoading: false,
  isExportTransactionByCustomerIdLoading: false,
  isGetTransactionInsuredLoading: false,
  isGetTransactionSummaryLoading: false,
  isGetTransactionDetailLoading: false,
  isUpdateCustomerTransactionInsuredLoading: false,
  isCancelCustomerInsuredLoading: false,
  isGetCustomerTransactionTaxInvoiceLoading: false,
  isUpdateCustomerTransactionTaxInvoiceLoading: false,
  isUpdateCustomerSentTaxInvoiceLoading: false,
  isCustomerActive: true,
  isEditCustomerInfo: false,
  isEditCustomerContact: false,
  isEditCustomerNote: false,

  // fetched
  fetchedTransactionInsured: []
}

const slice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    toggleCustomerActive: (state) => {
      state.isCustomerActive = !state.isCustomerActive
    },
    setIsEditCustomerInfo: (state, action: PayloadAction<boolean>) => {
      state.isEditCustomerInfo = action.payload
    },
    setIsEditCustomerContact: (state, action: PayloadAction<boolean>) => {
      state.isEditCustomerContact = action.payload
    },
    setIsEditCustomerNote: (state, action: PayloadAction<boolean>) => {
      state.isEditCustomerNote = action.payload
    },
    resetCustomerState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(CustomerService.getAllCustomersAsyncThunk.pending, (state) => {
        state.isGetAllCustomerLoading = true
      })
      .addCase(CustomerService.getAllCustomersAsyncThunk.rejected, (state) => {
        state.isGetAllCustomerLoading = false
      })
      .addCase(CustomerService.getAllCustomersAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllCustomerLoading = false
        state.fetchedAllCustomers = action.payload
      })
      .addCase(CustomerService.exportCustomersAsyncThunk.pending, (state) => {
        state.isExportCustomersLoading = true
      })
      .addCase(CustomerService.exportCustomersAsyncThunk.rejected, (state) => {
        state.isExportCustomersLoading = false
      })
      .addCase(CustomerService.exportCustomersAsyncThunk.fulfilled, (state) => {
        state.isExportCustomersLoading = false
      })
      .addCase(CustomerService.addCustomerAsyncThunk.pending, (state) => {
        state.isAddCustomerLoading = true
      })
      .addCase(CustomerService.addCustomerAsyncThunk.rejected, (state) => {
        state.isAddCustomerLoading = false
      })
      .addCase(CustomerService.addCustomerAsyncThunk.fulfilled, (state) => {
        state.isAddCustomerLoading = false
      })
      .addCase(CustomerService.getCustomerNameAsyncThunk.pending, (state) => {
        state.isGetCustomerNameLoading = true
      })
      .addCase(CustomerService.getCustomerNameAsyncThunk.rejected, (state) => {
        state.isGetCustomerNameLoading = false
      })
      .addCase(CustomerService.getCustomerNameAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerNameLoading = false
        state.fetchedCustomerName = action.payload
      })
      .addCase(CustomerService.getCustomerStatusAsyncThunk.pending, (state) => {
        state.isGetCustomerStatusLoading = true
      })
      .addCase(CustomerService.getCustomerStatusAsyncThunk.rejected, (state) => {
        state.isGetCustomerStatusLoading = false
      })
      .addCase(CustomerService.getCustomerStatusAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerStatusLoading = false
        state.fetchedCustomerStatus = action.payload
        state.isCustomerActive = action.payload
      })
      .addCase(CustomerService.getCustomerInfoAsyncThunk.pending, (state) => {
        state.isGetCustomerInfoLoading = true
      })
      .addCase(CustomerService.getCustomerInfoAsyncThunk.rejected, (state) => {
        state.isGetCustomerInfoLoading = false
      })
      .addCase(CustomerService.getCustomerInfoAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerInfoLoading = false
        state.fetchedCustomerInfo = action.payload
      })
      .addCase(CustomerService.getCustomerContactAsyncThunk.pending, (state) => {
        state.isGetCustomerContactLoading = true
      })
      .addCase(CustomerService.getCustomerContactAsyncThunk.rejected, (state) => {
        state.isGetCustomerContactLoading = false
      })
      .addCase(CustomerService.getCustomerContactAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerContactLoading = false
        state.fetchedCustomerContact = action.payload
      })
      .addCase(CustomerService.getCustomerNoteAsyncThunk.pending, (state) => {
        state.isGetCustomerNoteLoading = true
      })
      .addCase(CustomerService.getCustomerNoteAsyncThunk.rejected, (state) => {
        state.isGetCustomerNoteLoading = false
      })
      .addCase(CustomerService.getCustomerNoteAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerNoteLoading = false
        state.fetchedCustomerNote = action.payload
      })
      .addCase(CustomerService.getCustomerTimestampAsyncThunk.pending, (state) => {
        state.isGetCustomerTimestampLoading = true
      })
      .addCase(CustomerService.getCustomerTimestampAsyncThunk.rejected, (state) => {
        state.isGetCustomerTimestampLoading = false
      })
      .addCase(CustomerService.getCustomerTimestampAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerTimestampLoading = false
        state.fetchedCustomerTimestamp = action.payload
      })
      .addCase(CustomerService.updateCustomerStatusAsyncThunk.pending, (state) => {
        state.isUpdateCustomerStatusLoading = true
      })
      .addCase(CustomerService.updateCustomerStatusAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerStatusLoading = false
      })
      .addCase(CustomerService.updateCustomerStatusAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerStatusLoading = false
      })
      .addCase(CustomerService.updateCustomerInfoAsyncThunk.pending, (state) => {
        state.isUpdateCustomerInfoLoading = true
      })
      .addCase(CustomerService.updateCustomerInfoAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerInfoLoading = false
      })
      .addCase(CustomerService.updateCustomerInfoAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerInfoLoading = false
      })
      .addCase(CustomerService.updateCustomerContactAsyncThunk.pending, (state) => {
        state.isUpdateCustomerContactLoading = true
      })
      .addCase(CustomerService.updateCustomerContactAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerContactLoading = false
      })
      .addCase(CustomerService.updateCustomerContactAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerContactLoading = false
      })
      .addCase(CustomerService.updateCustomerNoteAsyncThunk.pending, (state) => {
        state.isUpdateCustomerNoteLoading = true
      })
      .addCase(CustomerService.updateCustomerNoteAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerNoteLoading = false
      })
      .addCase(CustomerService.updateCustomerNoteAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerNoteLoading = false
      })
      .addCase(CustomerService.getAllTransactionByCustomerIdAsyncThunk.pending, (state) => {
        state.isGetAllTransactionByCustomerIdLoading = true
      })
      .addCase(CustomerService.getAllTransactionByCustomerIdAsyncThunk.rejected, (state) => {
        state.isGetAllTransactionByCustomerIdLoading = false
      })
      .addCase(CustomerService.getAllTransactionByCustomerIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllTransactionByCustomerIdLoading = false
        state.fetchedAllTransactionByCustomerId = action.payload
      })
      .addCase(CustomerService.getCountTransactionByCustomerIdAsyncThunk.pending, (state) => {
        state.isGetCountTransactionByCustomerIdLoading = true
      })
      .addCase(CustomerService.getCountTransactionByCustomerIdAsyncThunk.rejected, (state) => {
        state.isGetCountTransactionByCustomerIdLoading = false
      })
      .addCase(CustomerService.getCountTransactionByCustomerIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetCountTransactionByCustomerIdLoading = false
        state.fetchedCountTransactionByCustomerId = action.payload
      })
      .addCase(CustomerService.exportTransactionByCustomerIdAsyncThunk.pending, (state) => {
        state.isExportTransactionByCustomerIdLoading = true
      })
      .addCase(CustomerService.exportTransactionByCustomerIdAsyncThunk.rejected, (state) => {
        state.isExportTransactionByCustomerIdLoading = false
      })
      .addCase(CustomerService.exportTransactionByCustomerIdAsyncThunk.fulfilled, (state) => {
        state.isExportTransactionByCustomerIdLoading = false
      })
      .addCase(CustomerService.getTransactionInsuredAsyncThunk.pending, (state) => {
        state.isGetTransactionInsuredLoading = true
      })
      .addCase(CustomerService.getTransactionInsuredAsyncThunk.rejected, (state) => {
        state.isGetTransactionInsuredLoading = false
      })
      .addCase(CustomerService.getTransactionInsuredAsyncThunk.fulfilled, (state, action) => {
        state.isGetTransactionInsuredLoading = false
        state.fetchedTransactionInsured = action.payload
      })
      .addCase(CustomerService.getTransactionSummaryAsyncThunk.pending, (state) => {
        state.isGetTransactionSummaryLoading = true
      })
      .addCase(CustomerService.getTransactionSummaryAsyncThunk.rejected, (state) => {
        state.isGetTransactionSummaryLoading = false
      })
      .addCase(CustomerService.getTransactionSummaryAsyncThunk.fulfilled, (state, action) => {
        state.isGetTransactionSummaryLoading = false
        state.fetchedTransactionSummary = action.payload
      })
      .addCase(CustomerService.getTransactionDetailAsyncThunk.pending, (state) => {
        state.isGetTransactionDetailLoading = true
      })
      .addCase(CustomerService.getTransactionDetailAsyncThunk.rejected, (state) => {
        state.isGetTransactionDetailLoading = false
      })
      .addCase(CustomerService.getTransactionDetailAsyncThunk.fulfilled, (state, action) => {
        state.isGetTransactionDetailLoading = false
        state.fetchedTransactionDetail = action.payload
      })
      .addCase(CustomerService.updateTransactionInsuredAsyncThunk.pending, (state) => {
        state.isUpdateCustomerTransactionInsuredLoading = true
      })
      .addCase(CustomerService.updateTransactionInsuredAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerTransactionInsuredLoading = false
      })
      .addCase(CustomerService.updateTransactionInsuredAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerTransactionInsuredLoading = false
      })
      .addCase(CustomerService.cancelInsuredAsyncThunk.pending, (state) => {
        state.isCancelCustomerInsuredLoading = true
      })
      .addCase(CustomerService.cancelInsuredAsyncThunk.rejected, (state) => {
        state.isCancelCustomerInsuredLoading = false
      })
      .addCase(CustomerService.cancelInsuredAsyncThunk.fulfilled, (state) => {
        state.isCancelCustomerInsuredLoading = false
      })
      .addCase(CustomerService.getCustomerTransactionTaxInvoiceByTransactionIdAsyncThunk.pending, (state) => {
        state.isGetCustomerTransactionTaxInvoiceLoading = true
      })
      .addCase(CustomerService.getCustomerTransactionTaxInvoiceByTransactionIdAsyncThunk.rejected, (state) => {
        state.isGetCustomerTransactionTaxInvoiceLoading = false
      })
      .addCase(CustomerService.getCustomerTransactionTaxInvoiceByTransactionIdAsyncThunk.fulfilled, (state, action) => {
        state.isGetCustomerTransactionTaxInvoiceLoading = false
        state.fetchedCustomerTransactionTaxInvoice = action.payload
      })
      .addCase(CustomerService.updateCustomerTransactionTaxInvoiceAsyncThunk.pending, (state) => {
        state.isUpdateCustomerTransactionTaxInvoiceLoading = true
      })
      .addCase(CustomerService.updateCustomerTransactionTaxInvoiceAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerTransactionTaxInvoiceLoading = false
      })
      .addCase(CustomerService.updateCustomerTransactionTaxInvoiceAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerTransactionTaxInvoiceLoading = false
      })
      .addCase(CustomerService.updateCustomerSentTaxInvoiceAsyncThunk.pending, (state) => {
        state.isUpdateCustomerSentTaxInvoiceLoading = true
      })
      .addCase(CustomerService.updateCustomerSentTaxInvoiceAsyncThunk.rejected, (state) => {
        state.isUpdateCustomerSentTaxInvoiceLoading = false
      })
      .addCase(CustomerService.updateCustomerSentTaxInvoiceAsyncThunk.fulfilled, (state) => {
        state.isUpdateCustomerSentTaxInvoiceLoading = false
      })
  }
})

export const {
  resetCustomerState,
  toggleCustomerActive,
  setIsEditCustomerInfo,
  setIsEditCustomerContact,
  setIsEditCustomerNote
} = slice.actions
export default slice.reducer
